<template>
    <div class="cl-artists-cont">
        <div id="genre-dropdown-container" style="margin-bottom: 15px; align-self: flex-end;">
            <GenreDropdown :on-click-list-item="onGenreSelected" />
        </div>
        <div style="display: flex; width: 100%;">
            <div class="cl-artists-title">Artists' loop packs</div>
        </div>
        <div class="cl-artists-list" v-if="collabs.length > 0">
            <ArtistCard v-for="(collab, index) in collabs" :key="index" :onSelectArtist="onSelectArtist" :collab="collab"/>
        </div>
        <div v-else class="cl-artists-list">
            No artists under genre {{ genre }}
        </div>
    </div>
</template>
<script>
    import ArtistCard from "./ArtistCard";
    import GenreDropdown from '@/components/GenreDropdown';
    export default {
      name: "CollabArtists",
      components: {
        ArtistCard,
        GenreDropdown,
      },
      props: {
        onSelectArtist: {
          type: Function
        },
        onGenreSelected: {
          type: Function
        },
        collabs: {
          type: Array,
          required: true
        }
      },
      data() {
        return {
          genre: 'All Music Genres',
          genreMenuOpen: false,
          genreList: [
            'All Music Genres',
            'Alternative',
            'Blues',
            'Classical',
            'Country',
            'Dance & Electronic',
            'Hip Hop/Rap',
            'Holiday',
            'Instrumental',
            'Jazz',
            'Musical Theatre',
            'Orchestra',
            'Pop',
            'R&B',
            'Rock',
            'Religious/Gospel',
            'Singer/Songwriter',
            'Vocal/A capella',
            'World'
          ]
        }
      },
      methods: {
        onPickGenre() {
          this.onGenreSelected(this.genre);
        }
      }
    }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
   .cl-artists-cont {
       padding: 2%;
       height: 100%;
       width: 100%;
       display: flex;
       flex-direction: column;
       align-items: center;
   }

    .cl-artists-title {
        font-size: 30px;
        font-family: SSNicksonFour, serif;
        margin-bottom: 10px;
        margin-left: 50px;
        width: 100%;
    }

    .cl-artists-list {
        display: flex;
        flex-wrap: wrap;
        padding: 0 3%;
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
        .cl-artists-list {
            justify-content: center;
            padding-bottom: 100px;
        }

        .cl-artists-title {
            font-size: 17px;
            margin-left: 24px;
        }
    }

    @media only screen and (min-width: 1000px) {
        .cl-artists-list {
            padding: 0 8%;
        }
    }

    @media only screen and (min-width: 501px) and (max-width: 770px) {
        .cl-artists-list {
            padding: 0;
        }
    }
</style>